import React from "react";
import { useEffect, useState } from "react";
import { accountRolesAndPermissions, AccountRolesAndPermissionsResponse } from "../../../../../modules/apis/OperatorApi";
import Pill from "../../../Pill";
import { StatusDto } from "../../../../../enums/Domain/Status";
import { OperatorPermissionsLevelSmartEnum } from "../../../../../enums/Domain/OperatorPermissionsLevelSmartEnum";

interface ISidePanelOperatorAccess {
    targetUserId : string
}

// Emulate two versions of this for operator and customer access display
export default function SidePanelOperatorAccess({targetUserId}: ISidePanelOperatorAccess) {
    const [accountRolesData, setAccountRolesData] = useState<AccountRolesAndPermissionsResponse>();
    const [canRender, setCanRender] = useState<boolean>(false);

    function getStatus(level: number){
        const statusDto = new StatusDto(level, OperatorPermissionsLevelSmartEnum.getName())
        return statusDto;       
    }

    useEffect(() => {
        async function getResponse() {
            if(targetUserId){
                setCanRender(false);
                const data = await accountRolesAndPermissions(targetUserId);
                setAccountRolesData(data);
                setCanRender(true);
            }
        }
        getResponse();
    }, [targetUserId])

    return (<>
        {!canRender &&
            <div className="side-panel__info-box margin__top--s">
                <div className={`display--flex alignItems--center flex__direction--column gap--s`}>
                    <div className={`form__wrapper form__wrapper`}>
                        <div className="loaders loaders__panel form__inline-loader"></div>
                    </div>
                </div>
            </div>
        }  
        {canRender && accountRolesData && accountRolesData?.accountRolesAndPermissionsResponse?.operatorAccess &&
            <div className="side-panel__info-box margin__top--s">
                <p className="small margin__bottom--xs">Roles & Access permissions</p>                
                <div className="side-panel__info">                    
                    <div className="side-panel__inline">
                        {<Pill statusDto={getStatus(accountRolesData.accountRolesAndPermissionsResponse.operatorAccess.level)} />}                       
                    </div>                    
                </div>
            </div>
        }
    </>
    )
}